import { TefComs4p } from '@mfe/components/TefComs4p';
import { textToUnsafeHTML } from '@mfec/lit/textToUnsafeHTML';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

interface TefOneModal extends HTMLElement {
  show() : Promise<unknown>;
}

// Open modal
export const handleClick = async (e : PointerEvent | null) => {
  if (!e?.target) return;
  await ((e.target as HTMLElement).nextElementSibling as TefOneModal).show();
};

//
// renders a <a> with a connected modal
//
export const tefPurposeDescriptionModal = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <span>
      <a href="#modal-purpose-${purpose.purposeId}" @click=${handleClick} style="white-space: nowrap">Weitere Informationen</a>
      <one-modal id="modal-purpose-${purpose.purposeId}" label="${purpose.title}" closable>
        <one-text as="p">
          ${textToUnsafeHTML(purpose.description)}
        </one-text>
      </one-modal>
    </span>
  `;
};
